/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Important_UpdateInputs */

const en_misc_important_update = /** @type {(inputs: Misc_Important_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important Update`)
};

const es_misc_important_update = /** @type {(inputs: Misc_Important_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización importante`)
};

/**
* | output |
* | --- |
* | "Important Update" |
*
* @param {Misc_Important_UpdateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const misc_important_update = /** @type {((inputs?: Misc_Important_UpdateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Important_UpdateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_misc_important_update(inputs)
	return en_misc_important_update(inputs)
});